import { useDatabaseEntity } from './useDatabaseEntity';

export interface ProblemDetails {
  id: string;
  title: string;
  description: string | undefined;
  reportedBy: string | undefined;
  resolved: boolean;
  resolvedAt: string | undefined;
  createdAt: string;
  updatedAt: string;
}

export function useProblem(problemId: string | undefined) {
  const { entity, loading, error } = useDatabaseEntity<ProblemDetails>(problemId, {
    entityType: 'Problem',
    build: (database, id) => {
      const obj = database.problems()[id];
      if (!obj) return null;
      return {
        id,
        title: obj.title(),
        description: obj.description() ?? undefined,
        reportedBy: obj.reported_by() ?? undefined,
        resolved: obj.resolved(),
        resolvedAt: obj.resolved_at() ?? undefined,
        createdAt: obj.created_at(),
        updatedAt: obj.updated_at(),
      };
    },
  });
  return { problem: entity, loading, error };
}
